import { apiUrl } from '../constants/global';
import { getLoggedUser } from '../state/user';
import axios from 'axios';
const user = getLoggedUser();

async function createOfficer(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'officers', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getAllOfficers(q) {
  return fetch(apiUrl + 'officers?' + q, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function getOfficer(id) {
  return fetch(apiUrl + 'officers/' + id, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function updateOfficer(payload, id) {
  let config = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'officers/update/' + id, payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

// function deleteOfficer(id) {
//   return fetch(apiUrl + "officers/" + id, {
//     method: "DELETE",
//     headers: {
//       "Content-Type": "applications/json",
//       Authorization: "Bearer " + user.token,
//     },
//   }).then((data) => data.json());
// }

async function deleteOfficer(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'delete_officer', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function getOfficerRanks(q) {
  return fetch(`${apiUrl}officer_ranks?${q}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  }).then((data) => data.json());
}

async function createOfficerRank(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'create_officer_rank', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function updateOfficerRank(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'update_officer_rank', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

async function deleteOfficerRank(payload) {
  let config = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + user.token,
    },
  };
  try {
    const { data: response } = await axios.post(apiUrl + 'delete_officer_rank', payload, config);
    return response;
  } catch (error) {
    console.log(error);
  }
}

export {
  createOfficer,
  getAllOfficers,
  getOfficer,
  updateOfficer,
  deleteOfficer,
  getOfficerRanks,
  createOfficerRank,
  updateOfficerRank,
  deleteOfficerRank,
};
